import React, { useEffect } from 'react';

function TextAnimation({ clssName, distance, easeTime }) {
    useEffect(() => {
        const headerMenuList = document.querySelectorAll(clssName);

        const showMenuList = (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const item = entry.target;
                    const aTag = item.querySelector('a');

                    if (aTag && aTag.innerText) {
                        const text = aTag.innerText;
                        aTag.innerHTML = ''; // aタグの中身をクリア
                        

                        text.split('').forEach((char, charIndex) => {
                            const charSpan = document.createElement('span');
                            charSpan.classList.add('spanAnimation');
                            charSpan.innerText = char;
                            charSpan.style.transition = 'transform 0.5s ease';
                            charSpan.style.display = 'inline-block';
                            charSpan.style.transform = `translateY(${distance})`;
                            aTag.appendChild(charSpan);

                            

                            setTimeout(() => {
                                charSpan.style.transform = 'translateY(0)';
                            }, easeTime * charIndex);
                        });
                    }
                    
                    setTimeout(() => {
                        item.classList.add('is-active');
                    }, 100 * (aTag?.innerText.length || 0) + 100);
                    
                    aTag.style.opacity = 1;
                    
                }
            });
        };

        // IntersectionObserverの設定
        const observer = new IntersectionObserver(showMenuList, {
            threshold: 0.1, // 10%見えたらトリガー
        });

        headerMenuList.forEach((item) => {
            observer.observe(item); // 各要素を監視
        });

        return () => {
            observer.disconnect(); // クリーンアップ
        };
    }, [clssName, distance, easeTime]);

    return null; // このコンポーネント自体はDOMに何もレンダーしない
}

export default TextAnimation;
